import React from 'react';
import { 
  FaUsers,
  FaUserTie,
  FaMapMarkerAlt,
  FaLightbulb,
  FaGraduationCap,
  FaUniversity,
  FaFileAlt,
  FaHome,
  FaPassport,
  FaMoneyBillWave,
  FaHandshake,
  FaStar,
  FaHeart,
  FaRocket,
  FaBullseye,
  FaGlobeEurope,
  FaBuilding,
  FaCogs,
  FaChartLine,
  FaShieldAlt,
  FaComments,
  FaCrown,
  FaChevronRight,
  FaGem,
  FaTrophy
} from 'react-icons/fa';
import { 
  FiUsers, 
  FiTarget, 
  FiAward,
  FiStar as FiStarIcon,
  FiCheckCircle
} from 'react-icons/fi';
import './EquipeETEF.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const EquipeETEF = () => {
  const founders = [
    {
      name: 'Kevin NZEUKENG',
      role: 'Fondateur & CEO',
      description: 'Visionnaire passionné par l\'éducation internationale, Kevin apporte une expertise approfondie dans la mobilité étudiante et la stratégie d\'entreprise. Son leadership guide notre mission quotidienne.',
      expertise: ['Mobilité étudiante', 'Éducation internationale', 'Stratégie d\'entreprise', 'Leadership'],
      icon: <FaUserTie />,
      color: "founder-1"
    },
    {
      name: 'Saïda ZIANI',
      role: 'Fondatrice & COO',
      description: 'Expert en partenariats institutionnels, Saïda apporte une vision stratégique pour le développement académique et les relations internationales, garantissant l\'excellence de nos services.',
      expertise: ['Partenariats institutionnels', 'Développement académique', 'Relations internationales', 'Gestion opérationnelle'],
      icon: <FaUserTie />,
      color: "founder-2"
    }
  ];

  const experts = [
    {
      title: 'Conseillers d\'orientation',
      icon: <FaGraduationCap />,
      description: 'Nos conseillers accompagnent quotidiennement les étudiants pour définir des projets d\'étude et professionnels cohérents, essentiels à la réussite de leur parcours en France.',
      features: ['Orientation personnalisée', 'Projet professionnel sur-mesure', 'Élaboration stratégique du parcours'],
      gradient: "expert-1"
    },
    {
      title: 'Responsables d\'admissions',
      icon: <FaUniversity />,
      description: 'Notre équipe d\'admissions possède une expertise reconnue dans l\'accompagnement des étudiants pour intégrer les meilleures universités et écoles françaises.',
      features: ['Admissions universitaires ciblées', 'Optimisation des dossiers', 'Procédures d\'inscription expertes'],
      gradient: "expert-2"
    },
    {
      title: 'Experts Campus France',
      icon: <FaFileAlt />,
      description: 'Nos spécialistes travaillent main dans la main avec les étudiants pour créer des dossiers Campus France irréprochables et préparer des entretiens réussis.',
      features: ['Dossiers Campus France optimisés', 'Préparation intensive aux entretiens', 'Stratégies de candidature gagnantes'],
      gradient: "expert-3"
    },
    {
      title: 'Spécialistes du Logement',
      icon: <FaHome />,
      description: 'Notre équipe logement déploie des solutions innovantes pour trouver les hébergements idéaux et gérer toute la documentation administrative associée.',
      features: ['Recherche logement sur-mesure', 'Solutions de garant locatif', 'Gestion documentaire complète'],
      gradient: "expert-4"
    },
    {
      title: 'Experts en visas étudiants',
      icon: <FaPassport />,
      description: 'Fortes de décennies d\'expérience, nos expertes en visas ont développé des méthodologies qui maximisent les chances d\'obtention.',
      features: ['Procédures visa optimisées', 'Dossiers consulaires renforcés', 'Taux de réussite exceptionnel'],
      gradient: "expert-5"
    },
    {
      title: 'Conseillers Financiers',
      icon: <FaMoneyBillWave />,
      description: 'Nos conseillers financiers élaborent des stratégies budgétaires adaptées et identifient toutes les solutions de financement disponibles.',
      features: ['Plans budgétaires personnalisés', 'Solutions de financement innovantes', 'Optimisation bancaire étudiante'],
      gradient: "expert-6"
    }
  ];

  const values = [
    {
      icon: <FaHeart />,
      title: 'Passion Éducative',
      description: 'Une passion profonde pour l\'éducation qui guide chaque accompagnement',
      color: "value-1"
    },
    {
      icon: <FaHandshake />,
      title: 'Engagement Total',
      description: 'Un engagement sans faille envers la réussite de chaque étudiant',
      color: "value-2"
    },
    {
      icon: <FaGem />,
      title: 'Excellence',
      description: 'Des services premium pour des résultats exceptionnels',
      color: "value-3"
    },
    {
      icon: <FaRocket />,
      title: 'Innovation Continue',
      description: 'Méthodes innovantes pour simplifier les démarches complexes',
      color: "value-4"
    },
    {
      icon: <FaBullseye />,
      title: 'Précision Chirurgicale',
      description: 'Un accompagnement méticuleux et personnalisé',
      color: "value-5"
    },
    {
      icon: <FaTrophy />,
      title: 'Expertise Reconnue',
      description: 'Une expertise certifiée dans la mobilité étudiante internationale',
      color: "value-6"
    }
  ];

  const teamStats = [
    { number: '15+', label: 'Experts spécialisés', icon: <FaUsers />, gradient: "stat-1" },
    { number: '1000+', label: 'Étudiants accompagnés', icon: <FaGraduationCap />, gradient: "stat-2" },
    { number: '98%', label: 'Taux de réussite', icon: <FaChartLine />, gradient: "stat-3" },
    { number: '50+', label: 'Écoles partenaires', icon: <FaUniversity />, gradient: "stat-4" }
  ];

  return (
    <section className="equipe-etef-sectionbigcontain">
      <Header />
      <section className="equipe-etef-main-section">
        
        {/* Background Elements */}
        <div className="equipe-background-elements">
          <div className="equipe-orb equipe-orb-1"></div>
          <div className="equipe-orb equipe-orb-2"></div>
          <div className="equipe-orb equipe-orb-3"></div>
          <div className="equipe-orb equipe-orb-4"></div>
          <div className="equipe-star equipe-star-1"></div>
          <div className="equipe-star equipe-star-2"></div>
          <div className="equipe-line equipe-line-1"></div>
          <div className="equipe-line equipe-line-2"></div>
        </div>

        <div className="equipe-container">
          {/* Hero Section */}
          <div className="equipe-hero-section">
            <div className="equipe-hero-content">
              <div className="equipe-hero-badge">
                <FiStarIcon className="equipe-badge-icon" />
                <span>Équipe d'Excellence</span>
              </div>
              <h1 className="equipe-hero-title">
                <span className="equipe-title-highlight">L'équipe</span> ETEF
              </h1>
              <div className="equipe-hero-subtitle-wrapper">
                <div className="equipe-location-tag">
                  <FaMapMarkerAlt className="location-icon" />
                  <span>Siège social à Marseille</span>
                </div>
                <p className="equipe-hero-description">
                  Une équipe d'experts dévoués qui accompagne chaque jour les étudiants dans la concrétisation 
                  de leurs projets académiques en France avec passion et professionnalisme.
                </p>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="equipe-stats-section">
            <div className="equipe-stats-header">
              <h2 className="equipe-stats-title">
                <FiTarget className="equipe-stats-icon" />
                Notre Impact en Chiffres
              </h2>
              <p className="equipe-stats-subtitle">
                Des réalisations qui témoignent de notre expertise et de notre engagement
              </p>
            </div>
            <div className="equipe-stats-grid">
              {teamStats.map((stat, index) => (
                <div key={index} className={`equipe-stat-card ${stat.gradient}`}>
                  <div className="equipe-stat-glow"></div>
                  <div className="equipe-stat-icon-wrapper">
                    {stat.icon}
                  </div>
                  <h3 className="equipe-stat-number">{stat.number}</h3>
                  <p className="equipe-stat-label">{stat.label}</p>
                  <div className="equipe-stat-decoration"></div>
                </div>
              ))}
            </div>
          </div>

          {/* Founders Section */}
          <div className="equipe-founders-section">
            <div className="equipe-section-header">
              <div className="equipe-header-decoration">
                <div className="equipe-header-line"></div>
                <FaCrown className="equipe-header-icon" />
                <div className="equipe-header-line"></div>
              </div>
              <h2 className="equipe-section-title">
                Les Visionnaires
              </h2>
              <p className="equipe-section-subtitle">
                Les fondateurs qui ont créé ETEF et continuent d'inspirer notre mission
              </p>
            </div>

            <div className="equipe-founders-grid">
              {founders.map((founder, index) => (
                <div key={index} className={`equipe-founder-card ${founder.color}`}>
                  <div className="founder-card-glow"></div>
                  <div className="founder-card-header">
                    <div className="founder-avatar-wrapper">
                      <div className="founder-avatar-bg"></div>
                      <div className="founder-avatar">
                        {founder.icon}
                      </div>
                    </div>
                    <div className="founder-info">
                      <div className="founder-badge">
                        <FiAward className="founder-badge-icon" />
                        {founder.role}
                      </div>
                      <h3 className="founder-name">{founder.name}</h3>
                    </div>
                  </div>
                  <div className="founder-card-body">
                    <p className="founder-description">{founder.description}</p>
                    <div className="founder-expertise">
                      <h4 className="expertise-title">
                        <FaLightbulb className="expertise-icon" />
                        Domaines d'Expertise
                      </h4>
                      <div className="expertise-tags">
                        {founder.expertise.map((item, idx) => (
                          <span key={idx} className="expertise-tag">
                            <FiCheckCircle className="tag-icon" />
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="founder-card-footer">
                    <div className="founder-signature">
                      <FaChevronRight className="signature-icon" />
                      <span>Leadership et Vision</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Experts Section */}
          <div className="equipe-experts-section">
            <div className="equipe-section-header">
              <h2 className="equipe-section-title">
                <FiUsers className="equipe-section-icon" />
                Notre Équipe d'Experts
              </h2>
              <p className="equipe-section-subtitle">
                Une équipe multidisciplinaire dédiée à l'excellence et à votre réussite
              </p>
            </div>

            <div className="equipe-experts-grid">
              {experts.map((expert, index) => (
                <div key={index} className={`equipe-expert-card ${expert.gradient}`}>
                  <div className="expert-card-glow"></div>
                  <div className="expert-card-header">
                    <div className="expert-icon-container">
                      <div className="expert-icon-wrapper">
                        {expert.icon}
                      </div>
                    </div>
                    <h3 className="expert-title">{expert.title}</h3>
                  </div>
                  <div className="expert-card-body">
                    <p className="expert-description">{expert.description}</p>
                    <div className="expert-features">
                      {expert.features.map((feature, idx) => (
                        <div key={idx} className="expert-feature">
                          <div className="feature-icon-wrapper">
                            <FaStar className="feature-icon" />
                          </div>
                          <span className="feature-text">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="expert-card-footer">
                    <div className="expert-cta">
                      <span>Expertise confirmée</span>
                      <FaChevronRight className="cta-arrow" />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="equipe-support-note">
              <div className="support-note-card">
                <div className="support-icon-wrapper">
                  <FaBuilding className="support-icon" />
                </div>
                <div className="support-content">
                  <h4 className="support-title">Écosystème Collaboratif</h4>
                  <p className="support-text">
                    Notre équipe s'appuie sur un réseau de professionnels talentueux qui travaillent en synergie 
                    pour offrir des services premium aux étudiants et à nos universités partenaires.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Values Section */}
          <div className="equipe-values-section">
            <div className="equipe-section-header">
              <h2 className="equipe-section-title">
                <FaGem className="equipe-section-gem" />
                Notre Philosophie d'Excellence
              </h2>
              <p className="equipe-values-intro">
                <FaHeart className="values-heart" />
                Chez ETEF, notre passion pour l'éducation se traduit par un engagement total envers 
                la réalisation de chaque rêve académique en France.
              </p>
            </div>

            <div className="equipe-values-grid">
              {values.map((value, index) => (
                <div key={index} className={`equipe-value-card ${value.color}`}>
                  <div className="value-card-glow"></div>
                  <div className="value-icon-container">
                    <div className="value-icon-wrapper">
                      {value.icon}
                    </div>
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                  <div className="value-decoration">
                    <div className="value-dot"></div>
                    <div className="value-dot"></div>
                    <div className="value-dot"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Call to Action */}
          <div className="equipe-cta-section">
            <div className="equipe-cta-card">
              <div className="equipe-cta-glow"></div>
              <div className="equipe-cta-content">
                <div className="cta-header">
                  <div className="cta-icon-wrapper">
                    <FaComments className="cta-icon" />
                  </div>
                  <div className="cta-title-wrapper">
                    <h2 className="cta-title">Rencontrez notre équipe d'experts</h2>
                    <p className="cta-subtitle">Votre réussite commence par un premier contact</p>
                  </div>
                </div>
                <div className="cta-body">
                  <p className="cta-description">
                    Notre équipe d'experts est prête à vous accompagner dans l'aventure de vos études en France. 
                    Prenez rendez-vous pour une consultation personnalisée et découvrez comment nous pouvons 
                    transformer votre projet académique en réalité.
                  </p>
                  <div className="cta-buttons">
                    <button className="cta-button primary">
                      <FaHandshake className="button-icon" />
                      <span>Planifier un entretien</span>
                      <FaChevronRight className="button-arrow" />
                    </button>
                    <button className="cta-button secondary">
                      <FaCogs className="button-icon" />
                      <span>Explorer nos services</span>
                      <FaChevronRight className="button-arrow" />
                    </button>
                  </div>
                </div>
                <div className="cta-footer">
                  <div className="cta-guarantee">
                    <FaShieldAlt className="guarantee-icon" />
                    <span>Accompagnement garanti de A à Z</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
};

export default EquipeETEF;